import { render } from "./courseSortButton.vue?vue&type=template&id=9a82e998"
import script from "./courseSortButton.vue?vue&type=script&lang=js"
export * from "./courseSortButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__